import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators, getCalendar } from "page/calendar/store";
import LayoutSelector from "./layout-selector";
import { getUserHasChangedBorder } from "event/store";
import { actionCreators as uiActionCreators } from "ui/store";

import {
    getIsLoadingLayoutOptions,
    getLayoutOptions,
    getBorderOptions,
    actionCreators as burdeContentActionCreators,
    getSelectedLayout,
    getFontOptions,
} from "burde-api-content/store";

const mapStateToProps = (state: ApplicationState) => ({
    calendar: getCalendar(state),
    userHasChangedBorder: getUserHasChangedBorder(state),
    borderOptions: getBorderOptions(state),
    layoutOptions: getLayoutOptions(state),
    isLoadingLayoutOptions: getIsLoadingLayoutOptions(state),
    calendarLayout: getSelectedLayout(state),
    fontOptions: getFontOptions(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
    ...burdeContentActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutSelector);
